module.exports = __webpack_public_path__ + "static/Nexa-Light-12108809f49c49bcdc126dcecc938761.otf";